import { render, staticRenderFns } from "./AnexoReadequacao.vue?vue&type=template&id=1f6e5bdc&scoped=true"
import script from "./AnexoReadequacao.vue?vue&type=script&lang=js"
export * from "./AnexoReadequacao.vue?vue&type=script&lang=js"
import style0 from "./AnexoReadequacao.vue?vue&type=style&index=0&id=1f6e5bdc&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6e5bdc",
  null
  
)

export default component.exports